import { dateToShow } from '@/helpers/dates'
import reduceWithSeparator from '@/helpers/reduce-with-separator'

const days = {
  sunday: 'dom',
  monday: 'seg',
  tuesday: 'ter',
  wednesday: 'qua',
  thursday: 'qui',
  friday: 'sex',
  saturday: 'sab'
}

const getDays = rule => {
  const keys = Object.keys(rule)
  const label = keys.reduce((acc, key) => {
    if (rule[key] && days[key]) {
      acc.push(days[key])
    }

    return acc
  }, [])

  return label.join(', ')
}

export default {
  prepareShow (rule) {
    rule.valid = dateToShow(rule.valid)
    rule.agenda.covenants = reduceWithSeparator(rule.agenda.covenants, 'name', ', ', 'Particular')
    rule.agenda.specialities = reduceWithSeparator(rule.agenda.specialities)
    rule.days = getDays(rule)

    return rule
  }
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/summary-agenda/resources/methods.js